<template>
  <div class="pt-8">
    <odoo-instance-table
      :instances="instances"
      @open-add-modal="openNewModal"
      @edit-instance="openEditModal"
      @refresh-list="fetchInstances"
    />

    <template v-if="showModal">
      <odoo-instance-form-modal
        :visible="showModal"
        :instanceData="formData"
        :isEditing="isEditing"
        @close-modal="closeModal"
        @saved="onSaved"
      />
    </template>
  </div>
</template>

<script>
import OdooInstanceTable from '../Components/OdooClientInstanceTable.vue';
import OdooInstanceFormModal from '../Components/OdooClientInstanceFormModal.vue';

import { mapMutations } from 'vuex';

export default {
  components: {
    OdooInstanceTable,
    OdooInstanceFormModal
  },
  data() {
    return {
      instances: [],
      showModal: false,
      isEditing: false,
      formData: {
        type: '',
        url: '',
        name: '',
        db_name: '',
        username: '',
        password: ''
      }
    };
  },
  created() {
    this.fetchInstances();
  },
  methods: {
    ...mapMutations(['setLoading']),
    async fetchInstances() {
      this.setLoading(true);
      try {
        const res = await this.$conectar.post('odoo-client-instance/list');
        if (res.data.success) {
          this.instances = res.data.data;
        }
      } catch (e) {
        console.error(e.response || e);
      }
      this.setLoading(false);
    },
    openNewModal() {
        this.isEditing = false;
        this.formData = {
            type: '',
            url: '',
            name: '',
            db_name: '',
            username: '',
            password: ''
        };
        this.showModal = true;
    },
    openEditModal(instance) {
        this.isEditing = true;
        this.formData = {
            id: instance.id,
            type: instance.type,
            url: instance.url,
            name: instance.name,
            db_name: instance.db_name,
            username: instance.username,
            password: '' // no mostrar la real, se deja vacío para no cambiar
        };
        this.showModal = true;
    },
    closeModal() {
        this.showModal = false;
    },
    onSaved() {
        this.showModal = false;
        this.fetchInstances();
    }
  }
};
</script>

<style scoped>
/* ajustes si necesitas */
</style>
